var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-seasons-calendar"},_vm._l((Object.keys(_vm.calendar)),function(month){return _c('c-seasons-month',{key:month,attrs:{"month":Number(month),"days-in-month":Object.keys(_vm.calendar[month])}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }